import React, { useState } from 'react';
import { Table as AntTable, Typography, Button, Space } from 'antd';
import { genNumberTable } from '../../../../function/genNumberTable';
import DetailsModal from './DetailsModal';
const { Title, Text } = Typography;

const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: 'center',
};

const Table = ({ data = [], loading = false, handleSearch, pagination, onPaginationChange }) => {
  const [modalReportVisible, setModalReportVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isDetail, setIsDetail] = useState(false);

  const columns = [
    {
      title: 'แจ้งโดย',
      dataIndex: 'report_by',
      key: 'report_by',
      align: 'center',
      // width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'ทำโดย',
      dataIndex: 'finish_by',
      key: 'finish_by',
      align: 'center',
      // width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'Note',
      dataIndex: 'report_remark',
      key: 'report_remark',
      align: 'center',
      // width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: 'User Name',
      dataIndex: 'user_id',
      key: 'user_id',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: 'CaseName',
      dataIndex: 'caseName',
      key: 'caseName',
      align: 'center',
      // width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || 0}</span>,
    },
    {
      title: 'Subcase',
      dataIndex: 'case3',
      key: 'case3',
      align: 'center',
      // width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text) => <span >{text ? `${Math.floor(text / 60)}:${text % 60} ` : '-'}</span>,
    },
    {
      title: 'Date',
      dataIndex: 'create_date',
      key: 'create_date',
      align: 'center',
      // width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text) => <span >{text ? `${Math.floor(text / 60)}:${text % 60} ` : '-'}</span>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      // width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => {
        const colors = {
          waiting: 'blue',
          Pass: 'green',
          Fail: 'red',
        };
        return (
          <span style={{ color: colors[text] || '#333', fontWeight: 500 }}>
            {text || '-'}
          </span>
        );
      },
    },
    {
      title: 'Audit Remark',
      dataIndex: 'audit_remark',
      key: 'audit_remark',
      align: 'center',
      // width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: "รายละเอียด",
      // fixed: "right",
      key: "actions",
      align: "center",
      //width: 100,
      render: (record) => {
        //if(record.status === 'Pass' || record.status === 'Fail') return null;
        return (
          <Space size="middle">
            <Button
              type="primary"
              onClick={() => {
                setModalReportVisible(true);
                setSelectedRecord(record);
                setIsDetail(true);
              }}
            >
              ดู
            </Button>
          </Space>
        );
      },
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: "การจัดการ",
      // fixed: "right",
      key: "actions",
      align: "center",
      //width: 100,
      render: (record) => {
        if(record.status === 'Pass' || record.status === 'Fail') return null;
        return (
          <Space size="middle">
            <Button
              type="primary"
              onClick={() => {
                setModalReportVisible(true);
                setSelectedRecord(record);
                setIsDetail(false);
              }}
            >
              จัดการ
            </Button>
          </Space>
        );
      },
      onHeaderCell: () => ({ style: headerStyle }),
    },
    // {
    //   title: 'รายละเอียด',
    //   key: 'details',
    //   align: 'center',
    //   width: 120,
    //   fixed: 'right',
    //   onHeaderCell: () => ({ style: headerStyle }),
    //   render: (_, record) => (
    //     <Button
    //       type="text"
    //       icon={<SearchOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
    //       onClick={() => handleViewDetails(record)}
    //       style={{ borderRadius: 6 }}
    //     />
    //   ),
    // },
  ];

  return (
    <div style={{ padding: '20px', background: '#fff' }}>
      <div className='overflow-x-auto'>
        <AntTable
          loading={loading}
          dataSource={data}
          columns={columns}
          scroll={{ x: 'max-content' }}
          bordered
          pagination={{
            current: pagination?.current || 1,
            pageSize: pagination?.pageSize || 10,
            total: pagination?.total || 0,
            showSizeChanger: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} จาก ${total} รายการ`,
            pageSizeOptions: ['10', '20', '50', '100'],
            onChange: (page, pageSize) => onPaginationChange?.(page, pageSize),
          }}
          rowKey={'id'}
        />

      </div>

      <DetailsModal
        visible={modalReportVisible}
        isDetail={isDetail || false}
        onClose={() => {
          setModalReportVisible(false);
          setSelectedRecord(null);
          handleSearch()
        }}
        recordId={selectedRecord?.id}
        inputId={selectedRecord?.input_id}
        report={selectedRecord}
        refetch={handleSearch}
      />
      <style>{`
        .table-row-light {
          background-color: #f5f5f5;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e8f4f8 !important;
        }
      `}</style>
    </div>
  );
};

export default Table;

